import { makeAutoObservable } from "mobx";
import { Kind } from "../../mst/base";

class K8sCrdContextMobx {
  supportedKinds: Kind[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  public setSupportedKinds(value: Kind[]) {
    this.supportedKinds = value;
  }
}

export const K8sCrdContext = new K8sCrdContextMobx();
